/**
 * Aggregate buckets API client.
 *
 * Maps 1:1 to `backend/src/hub/routes/aggregate_buckets.py`.
 */
import { api } from "./api";
import type { Paginated, PageSize } from "./pagination";

export interface BucketSummary {
  id: string;
  workflow_id: string;
  workflow_name: string;
  node_id: string;
  correlation_key: string;
  count: number;
  count_target: number | null;
  aggregation: string;
  status: "collecting" | "emitted" | "timed_out" | "expired";
  timeout_at: string | null;
  created_at: string;
  updated_at: string | null;
  emitted_at: string | null;
}

export interface BucketDetail extends BucketSummary {
  payloads: unknown[];
}

export const aggregateBucketsApi = {
  list: (params?: {
    workflow_id?: string;
    status?: BucketSummary["status"];
    page?: number;
    page_size?: PageSize;
  }) => {
    const qs = params
      ? "?" +
        Object.entries(params)
          .filter(([, v]) => v !== undefined)
          .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
          .join("&")
      : "";
    return api.get<Paginated<BucketSummary>>(`/aggregate-buckets${qs}`);
  },

  get: (id: string) => api.get<BucketDetail>(`/aggregate-buckets/${id}`),

  flush: (id: string) =>
    api.post<{ action: string }>(`/aggregate-buckets/${id}/flush`),

  delete: (id: string) => api.delete<void>(`/aggregate-buckets/${id}`),
};
